AllAnnouncements = require 'models/all-announcements'
AnnouncementHeaderView = require 'views/header/announcement-header-view'
Announcements = require 'models/announcements'
Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
Storage = require 'lib/storage'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'
{ locales } = require 'db/locale-information'
f = require 'effing'
pollify = require('common/lib/util/pollify').default

ONE_SECOND = 1000
THIRTY_SECONDS = ONE_SECOND * 30
ONE_MINUTE = THIRTY_SECONDS * 2
TEN_MINUTES = ONE_MINUTE * 10

module.exports = class HeaderWoofView extends View

  initialize: ->
    @makeDebouncedMethods 'renderTacoState'

    @listenTo Announcements, 'add remove reset',
      @renderTacoStateDebounced
    @listenTo AllAnnouncements, 'add remove reset change:unread',
      @renderTacoStateDebounced

    @updateAllAnnouncements = _.debounce(@updateAllAnnouncements, ONE_MINUTE, true)
    @pollingUpdateAnnouncements = pollify(@updateAnnouncements, TEN_MINUTES)
    @pollingShouldTacoShow = pollify(@renderTacoState, THIRTY_SECONDS)

    @pollingUpdateAnnouncements()
    @pollingShouldTacoShow()

  events:
    'click': 'openAnnouncement'
    'mouseover': 'updateAllAnnouncements'

  remove: ->
    super
    @pollingUpdateAnnouncements.clear()
    @pollingShouldTacoShow.clear()

  render: ->
    @$el.html templates.fill('woof_header')
    @renderTacoState()
    @

  renderTacoState: =>
    classes =
      alert: 'woof-alert'
      unread: 'woof-up'
      recentlyRead: 'woof-crouch'
      none: 'woof-hide'

    $btn = @$('.header-btn')

    for key, className of classes
      $btn.removeClass className

    # load dynimcally because may want to tailor this for
    # other announcement types later (maintenance, etc)
    if 'downtime' in _.pluck(Announcements.toJSON(), 'type')
      $btn.find('.js-phrase').text l('announcements.maintenance')
      $btn.addClass classes.alert
    else
      $btn.find('.js-phrase').text l('announcements.new stuff')

    $btn.addClass if @interestingAnnouncementCount() > 0
      classes.unread
    else if Storage.get('tacoShow') > Date.now()
      classes.recentlyRead
    else
      classes.none

    return

  interestingAnnouncementCount: ->
    Announcements.forLocale locales[0]
    .filter f.method('isUnread')
    .length

  updateAnnouncements: ->
    Announcements.fetch()

  updateAllAnnouncements: ->
    AllAnnouncements.fetch()

  openAnnouncement: (e) ->
    Util.stop(e)

    @updateAllAnnouncements()

    PopOver.toggle
      elem: @$('.header-btn')
      view: new AnnouncementHeaderView({ model: Auth.me(), @modelCache })

    track("Header", "Announcement", "Unread", @interestingAnnouncementCount())

    return



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-woof-view.coffee